module.exports = __webpack_public_path__ + "img/12.bb6941d7.png";